
import {PremiumServiceEventTypes} from "@/enums/PremiumServiceEventTypes";
import {ServiceStatus} from "@/enums/ServiceStatus";
import {mapState} from "vuex";

export default {
  data() {
    return {
      loading: true,
      headers: [
        { text: this.$t("ReportByResidents.ResidentStatus"), width: '200px', value: "resident.status"},
        { text: this.$t("GeneralTranslations.Resident"), width: '200px', align: "start", value: "resident.name"},
        { text: this.$t("ReportByResidents.Services"), width: '200px', value: "resident.conciergeServicesCount" },
        { text: this.$t("ReportByResidents.Requests"), width: '200px', value: "resident.conciergeRequestsCount" },
        { text: this.$t("ReportByResidents.Events"), width: '200px', value: "resident.eventsCount" },
        { text: this.$t("ReportByResidents.Products"), width: '200px', value: "resident.productsCount" },
        { text: this.$t("ReportByResidents.TotalSpent"), width: '200px', value: "resident.totalSpent" }
      ],
      jsonFields: {
        "Resident Status": "resident.status",
        "Resident": "resident.name",
        "Services": "resident.conciergeServicesCount",
        "Requests": "resident.conciergeRequestsCount",
        "Events": "resident.eventsCount",
        "Products":"resident.productsCount",
        "Total Spent": "resident.totalSpent"
      }
    };
  },
  props: {
    backButtomTitle: {
        type: String,
        default: 'Back'
      },
      backButtonRoute: {
        type: String,
        default: '/'
      },
  },
  async created() {
    await this.$store.dispatch("getServiceRequests");
    await this.$store.dispatch("getFacility");
    this.loading = false;
  },
  computed: {
    ...mapState({
      facility: state => (state as any).facilityModule.selectedFacility,
      residents: state => (state as any).residentModule.residentsShortData,
      requests: state => (state as any).additionalServicesModule.serviceRequests
    }),
    conciergeServices() {
      const requests = this.$store.state.additionalServicesModule.serviceRequests
        .filter(x => [
          PremiumServiceEventTypes.AppAccess,
          PremiumServiceEventTypes.ByAppointment,
          PremiumServiceEventTypes.Request,
          PremiumServiceEventTypes.Event,
          PremiumServiceEventTypes.EventBased,
          PremiumServiceEventTypes.ConciergeEvent,
          PremiumServiceEventTypes.Gift,
          PremiumServiceEventTypes.Product
        ].includes(x.serviceItemType));
      return requests
    },
    conciergeRequests() {
      const items = this.conciergeServices
        .filter(x => [
          PremiumServiceEventTypes.AppAccess,
          PremiumServiceEventTypes.ByAppointment,
          PremiumServiceEventTypes.Request
        ].includes(x.serviceItemType));

        return items
    },
    conciergeEvents() {
      const items = this.conciergeServices.filter(x => [
        PremiumServiceEventTypes.Event,
        PremiumServiceEventTypes.EventBased,
        PremiumServiceEventTypes.ConciergeEvent,
      ].includes(x.serviceItemType));

      return items
    },
    conciergeProducts() {
      const items = this.conciergeServices.filter(x => [
        PremiumServiceEventTypes.Gift,
        PremiumServiceEventTypes.Product
      ].includes(x.serviceItemType));

      return items
    },
    residentsWithServices() {
      return this.residents.map(resident => {

        const requests = this.conciergeServices.filter(x => x.residentId === resident.id && [ServiceStatus.Completed, ServiceStatus.Approved, ServiceStatus.AwaitingApproval].includes(x.status))

        const result = {
          resident: {
            ...resident,
            eventsCount: this.conciergeEvents.filter(x => x.residentId === resident.id && [ServiceStatus.Completed, ServiceStatus.Approved, ServiceStatus.AwaitingApproval].includes(x.status)).length,
            productsCount: this.conciergeProducts.filter(x => x.residentId === resident.id && [ServiceStatus.Completed, ServiceStatus.Approved, ServiceStatus.AwaitingApproval].includes(x.status)).length,
            conciergeRequestsCount: this.conciergeRequests.filter(x => x.residentId === resident.id && [ServiceStatus.Completed, ServiceStatus.Approved, ServiceStatus.AwaitingApproval].includes(x.status)).length,
            conciergeServicesCount: requests.length,
            totalSpent: `${this.facilityCurrency} ${this.calculateTotalSpent(requests)}`
          },
          requests: requests
        };

        return result;
      });
    },
    facilityCurrency() {
      return this.$store.getters.facilityCurrency;
    },
  },
  methods: {
    calculateTotalSpent(requests) {
        const completedItems = requests.filter(x=>[ServiceStatus.Completed, ServiceStatus.Approved, ServiceStatus.AwaitingApproval].includes(x.status))
        return completedItems.reduce((total, request) => {
          const paymentCost = parseFloat(request.paymentCost) || 0;
          const oneOffCost = parseFloat(request.oneOffCost) || 0;
          const subscriptionCost = parseFloat(request.subscriptionCost) || 0;
          const price = paymentCost || oneOffCost || subscriptionCost || 0
          total += Number(price) || 0;
          return total;
        }, 0);
      }
  }
};
